import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Node } from '@models/documents/directory/node.model';
import { DriveNameDisplayOptionsV2, DriveNameFolder } from '@app/types/translatables/drive-name-display.options';
import { SystemFolderNamesEnum } from '@documents-v2/enums';

export class FolderColumn extends Column {
    title = 'table.document-nodes-index.folder';
    sortable = false;
    type: CellDisplay = CellDisplay.string;
    hasIcon = true;

    getDisplayPropertyValue(node: Node): string | null {
        if (node.parent?.isFolder()) {
            return this.maybeSystemFolder(node.parent.name);
        }

        if (node.parent?.isDrive()) {
            return DriveNameDisplayOptionsV2[node.parent.name] ?? null;
        }

        return null;
    }

    getIcon(node: Node): string | null {
        if (node.parent?.isDrive()) {
            return DriveNameFolder[node.parent.name] ?? null;
        }

        // TODO
        //  Folder icon is unknown
        //  Expensive HTTP call to? /directories/nodes/{node}/drive

        // Guess the icon
        if (node.isEmployeeDocument()) {
            return 'folderPrivate';
        }
        if (node.isCompanyDocument()) {
            if (node.source?.isViewOnly()) {
                return 'folderShared';
            }
            return 'folderPrivate';
        }

        return null;
    }

    getIconStyle(): null | { [key: string]: string } {
        return {
            height: '20px',
            width: '20px',
            'padding-right': '0',
            'margin-right': '10px',
            'flex-shrink': '0',
        };
    }

    getRowStyling(): null | { [key: string]: string } {
        return {
            display: 'flex',
            'align-items': 'center',
        };
    }

    private maybeSystemFolder(x: string): string {
        const entries = Object.entries(SystemFolderNamesEnum) as [keyof typeof SystemFolderNamesEnum, string][];
        for (const [key, value] of entries) {
            if (value === x) {
                return `document.systemFolders.${key}`;
            }
        }
        return x;
    }
}
